import { shuffle } from "libp2p-gossipsub/src/utils";
export { getPredefinedBootstrapNodes } from "./predefined";
import * as predefined_1 from "./predefined";
export { predefined_1 as predefined };
export { Bootstrap } from "./bootstrap";
import * as dns_1 from "./dns";
export { dns_1 as dns };
export { DnsOverHttps } from "./dns_over_https";
export { ENRTree } from "./enrtree";
export function getPseudoRandomSubset(values, wantedNumber) {
    if (values.length <= wantedNumber) {
        return values;
    }
    return shuffle(values).slice(0, wantedNumber);
}
//# sourceMappingURL=index.js.map